module.exports = __webpack_public_path__ + "img/step33b_finger-stacker-hold - Copy.92bcf4cb.png";